module.exports = __webpack_public_path__ + "static/media/gold_pattern.fb7522bd.png";